import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Vue from 'vue';

gsap.registerPlugin(ScrollTrigger);

Vue.component('business-fleet-car-info-block-component', {
    props: {
        modelSpecs: {
            type: String,
        },
    },

    data() {
        return {
            areSpecsOpen: false,
        };
    },

    computed: {
        toggleModelSpecsClass() {
            return this.chapterOpen
                ? 'section-chapter--open model-new-section-chapter--custom-spacing'
                : '';
        },
    },

    created() {
        EventBus.$on('closeSpecs', () => {
            this.areSpecsOpen = false;
        });
    },

    mounted() {
        if (!JSON.parse(this.modelSpecs)) return;
        this.initSpecsClickHandler();
    },

    methods: {
        initSpecsClickHandler() {
            setTimeout(() => {
                document
                    .querySelector('a[href="#specification"]')
                    .addEventListener('click', this.toggleSeeFullSpecs);
            }, 1000);
        },

        toggleSeeFullSpecs(e) {
            e.preventDefault();
            this.areSpecsOpen = !this.areSpecsOpen;
            EventBus.$emit('openSpecs');
            // reset scrolltrigger when section opens/closes
            ScrollTrigger.refresh();
            if (this.areSpecsOpen) {
                gsap.fromTo(
                    this.$el.querySelector('.section-chapter'),
                    { height: 0 },
                    { height: 'auto', duration: 0.6 },
                );
            } else {
                gsap.fromTo(
                    this.$el.querySelector('.section-chapter'),
                    { height: 'auto' },
                    { height: 0, duration: 0.6, delay: 0.4 },
                );
            }
        },
    },
});
